import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setCommercialNum } from "../../../Redux/actions/CommercialSlice";
import { NavbarJourney } from "../../Navbar/NavbarJourney";
import { Form, Input, Button, Row, Select, Col, Spin, message } from "antd/lib";
import car1 from "../../../images/truck1.png";
import axiosCommercial from "../../../Redux/axios/AxiosCommercial";
import axios from "axios";
import {
  getCommercialDetails,
  setCommercialDetails,
} from "../../../Redux/actions/CommercialSlice";
import { addVahanData } from "../../../Redux/actions/NumBikeation";

const ComRegister = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
  const CommercialDetails = useSelector(getCommercialDetails);
  const ProdType = useSelector((state) => state?.common?.productType);
  const [formLayout] = useState("vertical");
  const [form] = Form.useForm();
  const { Option } = Select;
  const [open, setopen] = useState(false);
  const [loading, setLoading] = useState(false);

  const isuser = JSON.parse(localStorage.getItem("vibeUser"));

  const prefixSelector = (
    <Form.Item name="gender" noStyle>
      <Select
        style={{
          width: 70,
        }}
        defaultValue="+91"
      >
        <Option value="+91">+91</Option>
      </Select>
    </Form.Item>
  );
  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    setopen(true);
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    axios
      .post(`${BASEURL}v2/commercial_insurances/register`, {
        commercial_vehicle_number: values.truckNumber,
        phonenumber: values.phonenumber,
      })
      .then((res) => {
        console.log(res);
        if (res.status === 201) {
          let data = res.data.data;
          console.log("data", data);
           setLoading(false);
          dispatch(setCommercialNum(data));
          // localStorage.setItem("vibeReg", JSON.stringify(data));
          axiosCommercial
            .post(`getVehicleDetails`, {
              vehicleNumber: values.truckNumber,
            })
            .then((res) => {
              console.log(res);
              const truckResult = res.data.data;
              const { vibe_master } = truckResult;
              console.log("truckResult", truckResult);
              dispatch(addVahanData(truckResult));
              dispatch(
                setCommercialDetails({
                  ...CommercialDetails,
                  make: vibe_master?.Make,
                  model: vibe_master?.Model,
                  varient: vibe_master?.Variant,
                  VehicleCoreCode: vibe_master?.Vehicle_Core_Code,
                  RegYear: moment(truckResult?.registration_date).format(
                    "YYYY-MM-DD"
                  ),
                })
              );
              setLoading(false);

              // if (ProdType === vibe_master?.Product_Type) {
              if (ProdType === ProdType) {
                history.push(
                  `/commercial/${encodeURIComponent(
                    CommercialDetails?.commercialType
                      .toLowerCase()
                      .replace(/\s+/g, "-")
                  )}`
                );
              } else {
                message.info(
                  "Entered Vehicle Number is MisMatched with Selected Product"
                );
                setLoading(false);
                setopen(false);
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setopen(false);
      });
  };
  const onFinishFailed = (values) => {
    console.log(values);
  };

  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ truckNumber: e.target.value });
  };
  return (
    <>
      <NavbarJourney />
      <Spin spinning={loading}>
        <section
          className="bg-light d-flex align-items-center justify-content-center"
          style={{ minHeight: "calc(100vh - 50px)" }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-md-6 img-0 col-sm-12  p-2">
                <div className="m-4 ">
                  <img
                    alt="img"
                    className="img-fluid"
                    src="./Images/posp-login.png"
                  ></img>
                </div>
              </div>
              <div
                className="col-xl-6 col-md-6 col-sm-12 p-2 d-flex flex-column justify-content-center align-items-center p-4 outer-insur"
                style={{ height: "max-content" }}
              >
                {/* <div className='container d-flex justify-content-center'> */}
                {/* <div className='container'style={{maxHeight:'100vh'}}> */}
                <h4 className="text-blue">
                  Save upto 85%* on Commercial Insurance
                </h4>
                <p className="my-3">Stay home & renew in 2 minutes</p>
                <div className="d-flex align-items-center mt-4">
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fflash.png?alt=media&token=c7213ae8-4a09-4a72-9800-e6eb5e59ff75"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-success fw-bold">
                    Instant Policy
                  </small>
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fbank.png?alt=media&token=4cc16690-6e13-4219-a6ff-dd513fe04d1f"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-warning fw-bold">
                    Best Prices
                  </small>
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fdocuments.png?alt=media&token=7923cd01-4150-4801-a4bf-8a42120125c9"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-info fw-bold">
                    No Paperwork
                  </small>
                </div>
                <Form
                  layout={formLayout}
                  form={form}
                  style={{ width: "70%", paddingTop: "30px" }}
                  requiredMark={false}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    name="truckNumber"
                    rules={[
                      {
                        pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                        message: "Invalid Vehicle No",
                      },
                      { required: true, message: "Enter Vehicle No" },
                    ]}
                  >
                    <Input
                      onChange={handleInputChange}
                      placeholder="Enter Truck Number (eg. DL1SAB1234)"
                    ></Input>
                  </Form.Item>
                  <Form.Item
                    name="phonenumber"
                    rules={[
                      {
                        pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                        message: "Invalid Mobile No",
                      },
                      { required: true, message: "Enter Mobile No" },
                    ]}
                  >
                    <Input
                      maxLength={10}
                      addonBefore={prefixSelector}
                      placeholder="Enter Mobile Number (eg. 9876543210)"
                    ></Input>
                  </Form.Item>
                  <Row gutter={24} className="justify-content-center">
                    <Col span={24}>
                      <Form.Item>
                        <Button
                          style={{ width: "100%", borderRadius: "7px" }}
                          // loading={loading}
                          type="primary"
                          htmlType="submit"
                        >
                          View Price
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>

                <div
                  className=" mt-4 mb-5 h6 text-center"
                  style={{ fontSize: "0.7rem" }}
                >
                  <img
                    className="mx-1"
                    style={{ maxHeight: "0.8rem" }}
                    src={car1}
                    alt=""
                  />{" "}
                  <a href="#">Don't have a Truck number?</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Spin>
    </>
  );
};
export default ComRegister;
